import type { TypedChatWithMembers } from "@nexus/types"
import { createAsyncThunk } from "@reduxjs/toolkit"

interface LoadPlaygroundChatsParams {
  chats: TypedChatWithMembers[]
  hasNextPage: boolean
  page: number
}

/**
 * Load playground chat list
 * Populates the chats Record with chat instances from the backend
 */
export const loadPlaygroundChats = createAsyncThunk(
  "playgroundChat/loadChats",
  async ({ chats, hasNextPage, page }: LoadPlaygroundChatsParams) => {
    return { chats, hasNextPage, page }
  }
)
